function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#010101}");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3_2_"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_3_1_"
}, /*#__PURE__*/React.createElement("path", {
  id: "Layer_3",
  d: "M0 0h150v150H0V0z",
  fill: "none"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "tidal"
}, /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-45 74.958 105.1662)",
  className: "st1",
  d: "M57.3 87.5h35.3v35.3H57.3z"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-45 74.9668 55.1275)",
  className: "st1",
  d: "M57.3 37.5h35.3v35.3H57.3z"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-45 125.007 55.1199)",
  className: "st1",
  d: "M107.3 37.4h35.3v35.3h-35.3z"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-45 24.923 55.1188)",
  className: "st1",
  d: "M7.3 37.4h35.3v35.3H7.3z"
}));

var SvgTidal = function SvgTidal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logosandtypes_com",
    viewBox: "0 0 150 150",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTidal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tidal.ff998a64.svg";
export { ForwardRef as ReactComponent };